const PopupActions = {
  welcomeOpen: "welcomeOpen",
  welcomeClose: "welcomeClose",
  plotClose: "plotClose",
  plotSelect: "plotSelect",
  myLandsOpen: "myLandsOpen",
  walletOpen: "walletOpen",
  cityOpen: "cityOpen",
  aboutOpen: "aboutOpen",
};

export default PopupActions;
